import { RouteRecordRaw } from 'vue-router'

const SpendProjects = () =>
  import(/* webpackChunkName: "spend-projects-view" */ './pages/index.vue')

const SpendProjectForm = () =>
  import(/* webpackChunkName: "spend-project-form" */ './pages/FormPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'proyectos',
    name: 'spend-projects',
    component: SpendProjects,
    meta: {
      title: 'Proyectos',
      auth: {
        requiredPermission: 'spend_projects.view',
        requiredModule: 'spend_projects',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'proyectos/:ulid',
    name: 'spend-projects-edit',
    component: SpendProjectForm,
    meta: {
      title: 'Proyecto',
      auth: {
        requiredPermission: 'spend_projects.view',
        requiredModule: 'spend_projects',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
